// ФАЙЛ: ZonedEffectPortal.tsx
// НАЗНАЧЕНИЕ: Обёртка для эффектов, у которых backend передал зону компоновки
// (payload.zone / payload.overlayConfig.zone) — poll, drawing, soundboard.
// Регистрирует слот в ZoneLayoutManager через useZoneSlot и рендерит контент
// эффекта внутрь DOM-узла слота через портал, чтобы виджет физически попал в
// нужную зону сетки и корректно стековался с другими виджетами той же зоны.
//
// Вынесено в отдельный компонент, а не инлайн в EffectsLayer.map(), потому что
// хук useZoneSlot должен вызываться на каждом рендере консистентно — вызывать
// хуки условно внутри цикла .map() запрещено правилами React.

import { useZoneSlot, type ZoneId } from '@shared/lib/zone-layout'
import { createPortal } from 'react-dom'

interface ZonedEffectPortalProps {
  /** Стабильный id виджета для дедупликации слота (совпадает с id активного эффекта). */
  widgetId: string
  zone: ZoneId
  priority?: number
  children: React.ReactNode
}

export function ZonedEffectPortal({ widgetId, zone, priority, children }: ZonedEffectPortalProps) {
  const slotNode = useZoneSlot({ widgetId, zone, priority })

  // Провайдер зон не смонтирован (не должно происходить в норме, т.к.
  // ZoneLayoutManager всегда оборачивает EffectsLayer в OverlayPage) —
  // рендерим как есть, без портала, чтобы контент не терялся.
  if (!slotNode) return <>{children}</>

  return createPortal(children, slotNode)
}
